var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerminalListEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.5385 51.552C94.5385 62.2994 90.1487 71.9872 83.1099 78.9503C76.2225 85.8377 66.6861 90.0004 56.1657 90.0004C45.7211 90.0004 36.1846 85.762 29.2215 78.9503C22.1828 71.9872 17.793 62.2994 17.793 51.552C17.793 30.2842 34.9737 13.1035 56.1657 13.1035C77.3578 13.1035 94.5385 30.3599 94.5385 51.552Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2086 26.3488C92.9224 26.3488 94.3117 24.9595 94.3117 23.2457C94.3117 21.5319 92.9224 20.1426 91.2086 20.1426C89.4948 20.1426 88.1055 21.5319 88.1055 23.2457C88.1055 24.9595 89.4948 26.3488 91.2086 26.3488Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.752 14.2384C96.9224 14.2384 97.8712 13.2896 97.8712 12.1192C97.8712 10.9488 96.9224 10 95.752 10C94.5816 10 93.6328 10.9488 93.6328 12.1192C93.6328 13.2896 94.5816 14.2384 95.752 14.2384Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0059 26.2736C20.1763 26.2736 21.1251 25.3248 21.1251 24.1544C21.1251 22.984 20.1763 22.0352 19.0059 22.0352C17.8355 22.0352 16.8867 22.984 16.8867 24.1544C16.8867 25.3248 17.8355 26.2736 19.0059 26.2736Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06262 67.1428C8.23623 67.1428 9.99829 65.3808 9.99829 63.2072C9.99829 61.0335 8.23623 59.2715 6.06262 59.2715C3.88901 59.2715 2.12695 61.0335 2.12695 63.2072C2.12695 65.3808 3.88901 67.1428 6.06262 67.1428Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.111 31.4199V78.9507C76.2236 85.8381 66.6872 90.0008 56.1668 90.0008C45.7222 90.0008 36.1858 85.7624 29.2227 78.9507V31.4199H83.111Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9403 52H42.3906V55.4816H69.9403V52Z",
    fill: "#D5DAE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9403 59.6426H42.3906V63.1241H69.9403V59.6426Z",
    fill: "#D5DAE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2065 67.3652H49.1289V70.8468H63.2065V67.3652Z",
    fill: "#D5DAE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalListEmpty);
export default __webpack_public_path__ + "static/media/terminal-list-empty.2ec2c2e7ddaefb57631a2ccf4a14cd78.svg";
export { ForwardRef as ReactComponent };